// Webpack CSS import
import 'onsenui/css/onsenui.css';
//import 'onsenui/css/onsen-css-components.css';
import './assets/onsenui/perfarmer-onsen-css-components.css';
import './assets/style.css'; // CSS specific to this app

// JS import
import Vue from 'vue';
import VueOnsen from 'vue-onsenui';
import App from './App.vue';

Vue.config.productionTip = false;

Vue.use(VueOnsen);

Vue.prototype.$appVersion = process.env.VUE_APP_VERSION;
Vue.prototype.$apiDomain = process.env.VUE_APP_ROOT_API;
Vue.prototype.$telSupport = process.env.VUE_APP_TEL_SUPPORT;
Vue.prototype.$refreshInterval = process.env.VUE_APP_REFRESH_INTERVAL;

Vue.prototype.$getFetchInit = function (method, isNoJson) {
  var init = {
    method: method ? method : 'POST',
    mode: 'cors',
    credentials: 'include',
    headers: {
      'App-Version': process.env.VUE_APP_VERSION,
      'Content-Type': 'application/json'
    }
  };
  if (this.$device) {
    init.headers['App-Device'] = JSON.stringify(this.$device);
  }
  if (isNoJson) {
    delete init.headers['Content-Type'];
  }
  return init;
};
Vue.prototype.$setAutoFocus = function (el, cssSelector) {
  el.querySelector(cssSelector)._input.focus();
}
Vue.prototype.$scrollTop = function () {
  this.$el.querySelector('.page__content').scrollTo(0, 0);
}
Vue.prototype.$showToast = function (msg) {
  var modifier = this.$mdModifier;
  modifier += this.pageStack.length == 1 ? ' tabbar' : ''; // au lieu de animation: 'fall'
  this.$ons.notification.toast({
    message: msg ? msg : 'Synchronisation effectuée',
    timeout: 2000,
    modifier: modifier
  });
}
Vue.prototype.$redirectToStore = function () {
  if (typeof cordova === 'undefined') {
    window.location.reload();
  } else if(this.$md){
    cordova.InAppBrowser.open(process.env.VUE_APP_PLAYSTORE_LINK, '_system');
  } else {
    cordova.InAppBrowser.open(process.env.VUE_APP_APPSTORE_LINK, '_system');
  }
}
Vue.prototype.$callTel = function (tel) {
  if (! tel) {
    this.$ons.notification.alert({
      modifier: this.$mdModifier,
      title: "Numéro non disponible",
      message: "Le numéro de téléphone n'a pas été renseigné"
    });
  } else if (typeof cordova === 'undefined') {
    this.$ons.notification.alert({
      modifier: this.$mdModifier,
      title: "Appelez le numéro",
      messageHTML: '<a href="tel:' + tel + '">' + tel + '</a>'
    });
  } else {
    cordova.InAppBrowser.open('tel:' + tel, '_system');
  }
}
Vue.prototype.$getBadgeAsset = function (nbFeuille) {
  return require('./assets/imgs/badge_' + nbFeuille + 'feuille@2x.png');
}
Vue.prototype.$getCultAsset = function (refCulture, refDestination, type) {
  if(refDestination != 'conso'){
    refCulture += '-' + refDestination;
  }
  return 'url(' + this.$apiDomain + '/imgs/app/' + type + '/' + refCulture + '_' + type + '@2x.png),' +
    ' url(' + require('./assets/imgs/default_' + type + '@2x.png') + ')';
}
Vue.prototype.$splashScreen = function (event) {
  if(navigator.splashscreen){
    if(event == 'show' && ! this.$md){ // not supported by Android
      navigator.splashscreen.show();
    } else if(event == 'hide'){
      navigator.splashscreen.hide();
    }
  } else {
    // debug console.error('splashscreen not set');
  }
}
Vue.prototype.$showCrisp = function (Crisp, isHelpdesk, articleId) {
  Crisp.chat.show();
  if(isHelpdesk){
    Crisp.chat.setHelpdeskView();
    if(articleId){
      Crisp.chat.openHelpdeskArticle('fr', articleId);
    }
  } else {
    Crisp.chat.open();
  }
}


new Vue({
  el: '#app',  //.$mount('#app')
  //render: h => h(App),
  render(createElement) {
    return createElement(App, {
      props: {
        isResume: this.isResume,
        isDeepLink: this.isDeepLink,
        idPushNotif: this.idPushNotif,
        initPath: this.initPath,
        bgFetch: this.bgFetch,
      }
    })
  },
  data: {
    isAppRunning: true,
    isResume: 0,
    isDeepLink: 0,
    idPushNotif: '',
    initPath: '',
    bgFetch: {
      count: 0,
      done: null
    }
  },
  methods: {
    updatePushToken(token) {
      if (!token) {
        return;
      }
      var oldToken = localStorage.getItem('push_token');
      if (token == oldToken) {
        return;
      }
      
      var fd = new FormData();
      fd.append('push_token', token);
      if(oldToken){
        fd.append('old_token', oldToken);
      }
      var fetchInit = this.$getFetchInit('POST', true);
      fetchInit.body = fd;
      fetch(this.$apiDomain + '/push/token', fetchInit)
        .then(response => {
          localStorage.setItem('push_token', token);
        })
        .catch(error => {
          localStorage.removeItem('push_token');
        });
        
    }
  },
  beforeCreate() {

    //this.$ons.mockStatusBar();
    this.$ons.disableAutoStyling();
    this.$ons.enableAutoStatusBarFill();

    Vue.prototype.$md = this.$ons.platform.isAndroid();
    Vue.prototype.$mdModifier = Vue.prototype.$md ? 'material' : '';

    // Set iPhoneX flag based on URL
    if (this.$ons.platform.isIPhoneX()) {
      document.documentElement.setAttribute('onsflag-iphonex-portrait', '');
      document.documentElement.setAttribute('onsflag-iphonex-landscape', '');
    }

    this.$ons.ready(function () {
      if (! this.$ons.platform.isWebView()) {
        var hash = window.location.hash;
        if(hash.substring(0, 6) == '#/app/') {
          if (! ['login', 'new'].includes(hash.substring(6)) && (this.$ons.platform.isAndroid() || this.$ons.platform.isIOS())){
            window.location.href = this.$apiDomain + '/storelink';
          } else {
            this.initPath = hash.substring(1);
            this.isDeepLink += 1;
          }
        }
        return;
      }

      document.addEventListener('resume', function () {
        this.isAppRunning = true;
        this.isResume += 1;
      }.bind(this), false);

      document.addEventListener('pause', function () {
        this.isAppRunning = false;
      }.bind(this), false);

      if (this.$ons.platform.isIOS()) {
        wkWebView.injectCookie(this.$apiDomain + '/');
      }

      /*
      this.$ons.setDefaultDeviceBackButtonListener(function () {
        this.$ons.notification.confirm({
          modifier: 'material',
          title: 'Attention !',
          message: "Souhaitez-vous quitter l'application ?",
          buttonLabels: 'Quitter',
          cancelable: true
        }).then(function (index) {
          if (index === 0) { // -1 if canceled
            navigator.app.exitApp();
          }
        });
      }.bind(this));
      */

      //
      // ionic-plugin-deeplinks
      //
      IonicDeeplink.route({
      }, function(match) {
      }, function(nomatch) {
        // debug console.log('IonicDeeplink: ' + JSON.stringify(nomatch));
        if(nomatch.$link.path == '/app/maj'){
          this.$redirectToStore();
        } else if (nomatch.$link.path) {
          this.initPath = nomatch.$link.path;
          this.isDeepLink += 1;
        }
      }.bind(this));

      //
      // cordova-plugin-firebase
      //
      if(window.FirebasePlugin){
        window.FirebasePlugin.getToken(function (token) {
          this.updatePushToken(token);
        }.bind(this), function (error) {
          //console.error(error);
        });
        window.FirebasePlugin.onTokenRefresh(function (token) {
          this.updatePushToken(token);
        }.bind(this), function (error) {
          //console.error(error);
        });
        window.FirebasePlugin.onMessageReceived(function (notification) {
          // debug console.log('New notification: ' + JSON.stringify(notification));
          var notifId = notification.id;
          if(! notifId){
            notifId = notification['google.message_id'];
          }
          if(! notifId){
            notifId = new Date().getTime();
          }
          if(notification.tap){
            if(notification.path == '/app/maj'){
              this.$redirectToStore();
            } else {
              this.initPath = notification.path;
              this.idPushNotif = notifId + ' fg';
            }
          } else {
            this.initPath = '';
            this.idPushNotif = notifId + ' bg';
          }
        }.bind(this), function (error) {
          //console.error(error);
        });
      } else {
        // console.error('FirebasePlugin is not defined');
      }

      //
      // cordova-plugin-device
      //
      Vue.prototype.$device = {
        platform: device.platform,
        version: device.version,
        model: device.model,
        uuid: device.uuid
      };
      if (this.$ons.platform.isIOS()) {
        // Détection notch/DynamicIsland via safe-area, robuste en simulator et sur device
        // (device.model peut être "x86_64"/"arm64" en simulator et ne pas matcher le regex)
        var probe = document.createElement('div');
        probe.style.cssText = 'position:absolute;visibility:hidden;padding-top:env(safe-area-inset-top)';
        document.body.appendChild(probe);
        var safeAreaTop = parseFloat(getComputedStyle(probe).paddingTop) || 0;
        document.body.removeChild(probe);
        var isModernModel = /^iPhone1[1-9]/.test(device.model) && ['iPhone12,8', 'iPhone14,6'].indexOf(device.model) == -1;
        if (isModernModel || safeAreaTop > 20) {
          document.documentElement.setAttribute('onsflag-iphonex-portrait', '');
          document.documentElement.setAttribute('onsflag-iphonex-landscape', '');
        }
      }

    }.bind(this));

    this.$ons.ready(async function () {
      if(! this.$ons.platform.isWebView()) {
        return;
      }

      //
      // cordova-plugin-background-fetch
      //
      var bgFetch = window.BackgroundFetch;

      var bgFetchTriggerWatch = function (taskId, isTimeout) {
        return new Promise(resolve => {
          this.bgFetch.done = resolve;
          if(isTimeout){
            this.bgFetch.count = 0;
          } else {
            this.bgFetch.count += 1;
          }
          // debug console.log('[BackgroundFetch] triggered: ', taskId);
        });
      }.bind(this);

      var bgFetchOnEvent = async function(taskId) {
        // debug console.log('[BackgroundFetch] event received: ', taskId);
        // Required: Signal completion of your task to native code
        // If you fail to do this, the OS can terminate your app
        // or assign battery-blame for consuming too much background-time
        if(this.isAppRunning){
          // debug console.log('[BackgroundFetch] bypass: ', taskId);
          bgFetch.finish(taskId);
        } else {
          await bgFetchTriggerWatch(taskId);
          // debug console.log('[BackgroundFetch] finish: ', taskId);
          bgFetch.finish(taskId);
        }
      }.bind(this);

      var bgFetchOnTimeout = async function(taskId) {
        await bgFetchTriggerWatch(taskId, true);
        // debug console.log('[BackgroundFetch] TIMEOUT: ', taskId);
        bgFetch.finish(taskId);
      }.bind(this);

      var bgFetchStatus = await bgFetch.configure(
        {
          minimumFetchInterval: 15, // Math.max(15, this.$refreshInterval / 60),
          requiredNetworkType: bgFetch.NETWORK_TYPE_ANY
        },
        bgFetchOnEvent,
        bgFetchOnTimeout
      );
      // debug console.log('[BackgroundFetch] configure status: ', bgFetchStatus);
    }.bind(this));
    
  }
});
